export default "No contact info available";